// extracted by mini-css-extract-plugin
export default {"article_header":"Card_article_header__N8EEI","article_para":"Card_article_para__IQzEQ","article_link":"Card_article_link__p015D"};